import { IDocumentRelation } from '@query/documentRelations'
import React from 'react'

import { RelationGroup } from './RelationGroup'
import {
  RelationMapperThemeMode,
  RelationsContainer,
  RelationsMapperContent
} from './RelationMapper.styled'
import { DocumentRelationContext, getRelationMapperDisplayAmounts } from './relationMapperUtils'

const noopRemove = () => {}

export interface RelationReadOnlySummaryProps extends DocumentRelationContext {
  relations: IDocumentRelation[]
  themeMode?: RelationMapperThemeMode
  isFooterLoading?: boolean
}

export const RelationReadOnlySummary: React.FC<RelationReadOnlySummaryProps> = ({
  relations,
  themeMode = 'dark',
  isFooterLoading = false,
  sourceDocumentAmount,
  dueAccountEffect,
  accrualPairDueEffect,
  hasAccrualPairDueMismatch,
  accrualPairInvoiceTotal,
  accrualPairPaymentTotal
}) => {
  const { sourceAmount, networkInvoiceTotal, networkPaymentTotal, liveOpenAmount, hasMismatch } =
    getRelationMapperDisplayAmounts({
      relations,
      role: relations[0]?.role,
      sourceDocumentAmount,
      dueAccountEffect,
      accrualPairDueEffect,
      hasAccrualPairDueMismatch,
      accrualPairInvoiceTotal,
      accrualPairPaymentTotal
    })

  if (relations.length === 0) {
    return null
  }

  return (
    <RelationsContainer>
      <RelationsMapperContent>
        <RelationGroup
          relations={relations}
          onRemove={noopRemove}
          readOnly
          themeMode={themeMode}
          sourceAmount={sourceAmount}
          openAmount={liveOpenAmount}
          hasMismatch={hasMismatch}
          networkInvoiceTotal={networkInvoiceTotal}
          networkPaymentTotal={networkPaymentTotal}
          isFooterLoading={isFooterLoading}
        />
      </RelationsMapperContent>
    </RelationsContainer>
  )
}
